import { useEffect, useMemo, useState } from "react";
import IndividualWeekSettingsContent from "../../../../modal/ConsultationModals/Content/IndividualWeekSettings/Calendar/IndividualWeekSettingsContent";
import { getCurrentWeek } from "../../legacyUtils";
import { WeekDaysBox } from "../StyledComponents";
import { generateWeek, getWeekInterval } from "./utils";
import WeekDay from "./WeekDay";
import WeekDayTemplate from "./WeekDayTemplate";
import {useTranslation} from "react-i18next";

interface Props {
    week: number;
    setWeekInterval: React.Dispatch<
        React.SetStateAction<readonly [Date, Date]>
    >;
    isSettings: boolean;
}

const WeekDays = ({ week, setWeekInterval, isSettings }: Props) => {
    const [weekDiff, setWeekDiff] = useState(0);
    const [weekDays, setWeekDays] = useState(() => generateWeek(0));

    const currentWeek = useMemo(() => getCurrentWeek(), []);
    const isNextYear = currentWeek > week;
    const {t} = useTranslation();

    useEffect(
        () => setWeekDiff(week - currentWeek + (isNextYear ? 52 : 0)),
        [week, currentWeek, isNextYear]
    );

    useEffect(() => {
        setWeekDays(generateWeek(weekDiff));
        setWeekInterval(getWeekInterval(weekDiff));
    }, [setWeekInterval, weekDiff]);

    return (
        <WeekDaysBox>
            {!isSettings && <WeekDayTemplate />}
            {isSettings ? (
                <IndividualWeekSettingsContent
                    week={week}
                    weekDays={weekDays}
                />
            ) : (
                weekDays.map((day, i) => (
                    <WeekDay
                        key={day.dateString}
                        dayIndex={i}
                        week={week}
                        dayDate={day.date}
                        dayDateString={day.dateString}
                        dayName={t(day.name)}
                    />
                ))
            )}
        </WeekDaysBox>
    );
};

export default WeekDays;
